// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4584":"56682d95","8975":"f7647a35"}[chunkId] + ".chunk.css";
};